// ============================================================================
//  lineToggle — przełączniki linii boiska z wzajemnym wykluczaniem. Definicja
//  linii (LINE_DEFS) może wskazywać `excludes`: włączenie linii gasi wskazaną.
//  Półkole RW ↔ koło RW to dwa warianty TEGO SAMEGO oznaczenia — nie mogą być
//  namalowane naraz. Czyste funkcje (bez DOM): main (klik w checkbox) i kodek
//  zapisu/linku (śmieci z oboma włączonymi) korzystają z tej samej reguły.
// ============================================================================
import { LINE_DEFS } from '../constants.js'

// Nowa maska linii po przełączeniu `key` na `value`. Wyłączenie niczego nie
// włącza (oba warianty mogą być wyłączone). Nie mutuje wejścia.
export function toggleLine(lines, key, value, defs = LINE_DEFS) {
  const next = { ...lines, [key]: value }
  const def = defs.find((d) => d.key === key)
  if (value && def?.excludes) next[def.excludes] = false
  return next
}

// Rozstrzyga konflikty w gotowej masce (np. link z oboma wariantami RW): przy
// obu włączonych zostaje linia WCZEŚNIEJSZA w LINE_DEFS (półkole nad kołem).
export function resolveLineExclusions(lines, defs = LINE_DEFS) {
  const out = { ...lines }
  defs.forEach((d) => {
    if (d.excludes && out[d.key] && out[d.excludes]) out[d.excludes] = false
  })
  return out
}
